{
  "roles": "Roles",
  "listOfRoles": "Lista de Roles",
  "roleTitle": "Rol - {{description}}",
  "save": "Guardar",
  "nameLabel": "Nombre",
  "informationAccessLabel": "Acceso a Información",
  "informationUpdatesLabel": "Actualizaciones de Información",
  "addNewRoleTitle": "Agregar nuevo Rol",
  "deleteRoleTitle": "¿Está seguro de que desea eliminar el rol?",
  "deleteRoleSubtitle": "Esta acción eliminará permanentemente el rol y no se puede deshacer. ¿Desea continuar?",
  "deleteRoleCancel": "No, Mantener Rol",
  "deleteRoleConfirm": "Sí, Eliminar Rol",
  "deleteRoleLabel": "Eliminar rol {{description}}",
  "backToRoles": "Volver a la Lista de Roles"
}
